import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('inventory_logs')

export class InvntoryLogs{
    @PrimaryGeneratedColumn("increment",{name:'inventory_log_id'})
    inventoryLogId:number;

    @Column('int',{name:'old_location_id'})
    oldLocationId:number

    @Column('int',{name:'new_location_id'})
    newLocationId:number

    @Column('int',{name:'old_sale_order_id'})
    oldSaleOrderId:number

    @Column('int',{name:'new_sale_order_id'})
    newSaleOrderId:number

    @Column('int',{name:'stock_id'})
    stockId:number

    @Column('int',{name:'old_quantity'})
    oldQuantity:number 

    @Column('int',{name:'updated_quantity'})
    updatedQuantity:number

    @Column({name:'created_at'})
    createdAt:Date
    
}